/**-----------------------------------------------------------------------------
 * Enables HTML elements to trigger actions in the embed mobi2go store front
 */
import jQuery from 'jquery';
import _ from 'lodash';

const { Order, Menu, UI, Customer } = Mobi2Go;

UI.attachActionsToElement = function(element) {
    const $el = jQuery(element);

    /**-------------------------------------------------------------------------
     * Location
     *
     * Example:
     * <div data-m2g-set-location="newtown"></div>
     *  Or
     * <a data-m2g-set-location="newtown"></div>
     */
    $el.on('click', '[data-m2g-set-location]', function() {
        const location = jQuery(this).attr('data-m2g-set-location');
        setLocationByNameAndScroll(location);
    });

    $el.on('click', 'a[href="#set-location"]', function() {
        const location = jQuery(this).attr('title');
        setLocationByNameAndScroll(location);

        return false;
    });

    function setLocationByNameAndScroll(name) {
        Order.setLocationByName(name);

        if (Order.getLocation()) {
            UI.helpers.scrollTo(
                '[data-view="order-location"]',
                function() {
                    setTimeout(function() {
                        UI.alert({
                            title: 'Store set',
                            body: `Ordering from  ${Order.getLocation().name}`,
                            el: jQuery(
                                '[data-view="order-location"] [data-order-location]'
                            ).parent(),
                            placement: 'left',
                            primary_button: null,
                            temp: true,
                            highlight_element: true,
                        });
                    }, 250);
                },
                true,
                -150
            );
        }
    }

    /**-------------------------------------------------------------------------
     * Add Product
     *
     * Example:
     * <div data-m2g-add-product="burger"></div>
     */
    $el.on('click', '[data-m2g-add-product]', function() {
        const $this = jQuery(this);
        const id = $this.attr('data-m2g-add-product');

        const active_menu = Order.getMenu();
        let product =
            active_menu.getProductByName(id) ||
            active_menu.getProductByDisplayName(id) ||
            active_menu.getProductById(id);

        if (product) {
            const modifiers_string = $this.attr(
                'data-m2g-add-product-modifiers'
            );
            var modifiers = [];

            if (modifiers_string) {
                var modifiers = _.map(modifiers_string.split(','), function(
                    modifier_string
                ) {
                    return {
                        menu_modifier: {
                            name: jQuery.trim(modifier_string),
                        },
                        selection_state: 'on',
                    };
                });
            }

            product = product.createOrderProductInstance();
            if (modifiers.length) {
                product.set({ modifiers });
            }

            Order.addProduct(product);
        }
    });

    $el.on('click', 'a[href="#add-product"]', function() {
        const id = jQuery(this).attr('title');
        const active_menu = Order.getMenu();
        const product =
            active_menu.getProductByName(id) ||
            active_menu.getProductByDisplayName(id) ||
            active_menu.getProductById(id);

        if (product) {
            Order.addProduct(product.createOrderProductInstance());
        }

        return false;
    });

    /**-------------------------------------------------------------------------
     * Open Product
     *
     * Example:
     * <div data-m2g-open-product="burger"></div>
     */
    $el.on('click', '[data-m2g-open-product]', function() {
        const $this = jQuery(this);
        const id = $this.attr('data-m2g-open-product');

        const active_menu = Order.getMenu();
        let product =
            active_menu.getProductByName(id) ||
            active_menu.getProductByDisplayName(id) ||
            active_menu.getProductById(id);

        if (product) {
            const modifiers_string = $this.attr(
                'data-m2g-open-product-modifiers'
            );
            var modifiers = [];

            if (modifiers_string) {
                var modifiers = _.map(modifiers_string.split(','), function(
                    modifier_string
                ) {
                    return {
                        menu_modifier: {
                            name: jQuery.trim(modifier_string),
                        },
                        selection_state: 'on',
                    };
                });
            }

            product = product.createOrderProductInstance();
            if (modifiers.length) {
                product.set({ modifiers });
            }

            UI.trigger('editProduct', product);
        }
    });

    $el.on('click', 'a[href="#open-product"]', function() {
        const id = jQuery(this).attr('title');
        const active_menu = Order.getMenu();
        const product =
            active_menu.getProductByName(id) ||
            active_menu.getProductByDisplayName(id) ||
            active_menu.getProductById(id);

        if (product) {
            UI.trigger('editProduct', product.createOrderProductInstance());
        }

        return false;
    });

    /**-------------------------------------------------------------------------
     * Show Menu Category
     *
     * Example:
     * <div data-m2g-show-menu-category="Pasta"
     *      data-m2g-show-menu-category-selected-class="selected">
     *
     * "selected-class" value will added to element's class when clicked and removed
     * from all other elements in the DOM with the same the "show-menu-category" attr
     */
    $el.on('click', '[data-m2g-show-menu-category]', function() {
        const $this = jQuery(this);
        const id = $this.attr('data-m2g-show-menu-category');
        const selected_class = $this.attr(
            'data-m2g-show-menu-category-selected-class'
        );
        const categories = Order.getMenu().getCategories();
        const category = categories.getById(id) || categories.getByName(id) || categories.getByBackendName(id);

        if (category) {
            UI.trigger('showCategory', category.id);
            UI.trigger('scrollToCategory', category.id, true);

            if (selected_class) {
                jQuery('[data-m2g-show-menu-category]').removeClass(
                    selected_class
                );
                $this.addClass(selected_class);
            }
        }
    });

    $el.on('click', 'a[href="#show-menu-category"]', function() {
        const id = jQuery(this).attr('title');
        const offset = jQuery(this).attr('data-offset');
        const categories = Order.getMenu().getCategories();
        const category = categories.getById(id) || categories.getByName(id) || categories.getByBackendName(id);

        if (category) {
            UI.trigger('showCategory', category.id);
            UI.trigger('scrollToCategory', category.id, true, offset);
        }

        return false;
    });

    $el.on('click', 'a[href="#scroll-to-menu-category"]', function() {
        const id = jQuery(this).attr('title');
        const offset = jQuery(this).attr('data-offset');
        const categories = Order.getMenu().getCategories();
        const category = categories.getById(id) || categories.getByName(id) || categories.getByBackendName(id);

        if (category) {
            UI.trigger('scrollToCategory', category.id, true, offset);
        }

        return false;
    });

    /**-------------------------------------------------------------------------
     * Voucher Code
     *
     * Example:
     * <div data-m2g-set-voucher-code="freestuff"></div>
     */
    $el.on('click', '[data-m2g-set-voucher-code]', function() {
        const voucher_view = UI.views.order_voucher;
        const voucher_code = jQuery(this).attr('data-m2g-set-voucher-code');
        Order.setVoucherCode(voucher_code);
        if (voucher_view) {
            UI.helpers.scrollTo(voucher_view.$el, null, null, -50);
        } else {
            UI.page.change('order-editor');
        }
    });

    $el.on('click', 'a[href="#set-voucher-code"]', function() {
        const voucher_view = UI.views.order_voucher;
        const voucher_code = jQuery(this).attr('title');
        Order.setVoucherCode(voucher_code);

        if (voucher_view) {
            UI.helpers.scrollTo(voucher_view.$el, null, null, -50);
        } else {
            UI.page.change('order-editor');
        }
    });

    /**-------------------------------------------------------------------------
     * Menu
     */
    $el.on('click', '[data-m2g-set-menu]', function() {
        const $this = jQuery(this);
        const id = $this.attr('data-m2g-set-menu');
        const menus = Menu.getMenus();
        const menu = menus.getById(id) || menus.getByName(id);

        if (menu) {
            Order.setMenu(menu);
        }
    });

    $el.on('click', 'a[href="#set-menu"]', function() {
        const id = jQuery(this).attr('title');
        const menus = Menu.getMenus();
        const menu = menus.getById(id) || menus.getByName(id);

        if (menu) {
            Order.setMenu(menu);
        }
    });

    $el.on('click', 'a[href="#show-menu-page"]', function() {
        const page = jQuery(this).attr('title');

        switch (page) {
            case 'customer-register':
                UI.trigger('showRegister');
                break;
            case 'customer-login':
                UI.trigger('showLogIn');
                break;
            case 'customer-register-login':
                if (Customer.getSavedEmail()) {
                    UI.trigger('showLogIn');
                } else {
                    UI.trigger('showRegister');
                }
                break;
            case 'order-editor':
                UI.trigger('showOrderEditor');
                break;
            default:
                UI.page.change(page);
                break;
        }

        return false;
    });
};

Mobi2Go.onReady(function() {
    UI.attachActionsToElement('body');
});
